import React from "react";
import { Offcanvas } from "react-bootstrap";

const MailTemplatePreview = ({ Show, Hide, Title, htmlContent }) => {
  const iframeSrc = htmlContent || "<h3>No content available</h3>";

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 720 }}>
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0 overflow-hidden">
        <iframe
          title="Template Preview"
          className="w-100 h-100 border-0"
          srcDoc={iframeSrc}
        ></iframe>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MailTemplatePreview;
